export default "__VITE_ASSET__NwX9SmF5__"